import { API_URL } from "./../const";

export const fetchModulePurchaseData = (filterData, params) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    const query = new URLSearchParams({
        page: params.page.toString(),
        pageSize: params.pageSize.toString(),
    });

    return fetch(API_URL + `/api/v1/reports/module-purchases?${query}`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            courseType: filterData.courseType,
            permissionType: filterData.permissionType,
        })
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(response.status);
        }
    }).then((data) => {
        return data;
    }).catch((error) => {
        throw new Error(error);
    });
}

export const getModulePurchaseCsv = (filterData) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    return fetch(API_URL + `/api/v1/reports/module-purchases/export`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            courseType: filterData.courseType,
            permissionType: filterData.permissionType,
        })
    }).then((response) => {
        if (response.ok) {
            const disposition = response.headers.get('Content-Disposition');
            let filename = 'module_purchases_report_data.csv';

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            return response.blob().then(blob => ({ blob, filename }));
        } else {
            throw new Error(response.status);
        }
    }).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return link;
    }).catch((error) => {
        throw new Error(error);
    });
}

export const fetchTransactionsReportData = (filterData, params) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    const query = new URLSearchParams({
        page: params.page.toString(),
        pageSize: params.pageSize.toString(),
    });

    return fetch(API_URL + `/api/v1/reports/transactions?${query}`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            transactionType: filterData.transactionType,
            excludeSignupBonus: filterData.excludeSignupBonus,
        })
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(response.status);
        }
    }).then((data) => {
        return data;
    }).catch((error) => {
        throw new Error(error);
    });
}

export const getTransactionReportCsv = (filterData) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    return fetch(API_URL + `/api/v1/reports/transactions/export`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            transactionType: filterData.transactionType,
            excludeSignupBonus: filterData.excludeSignupBonus,
        })
    }).then((response) => {
        if (response.ok) {
            const disposition = response.headers.get('Content-Disposition');
            let filename = 'transactions_report_data.csv';

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            return response.blob().then(blob => ({ blob, filename }));
        } else {
            throw new Error(response.status);
        }
    }).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return link;
    }).catch((error) => {
        throw new Error(error);
    });
}

export const fetchRegisteredUsersReportData = (filterData, params) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    const query = new URLSearchParams({
        page: params.page.toString(),
        pageSize: params.pageSize.toString(),
    });

    return fetch(API_URL + `/api/v1/reports/registered-users?${query}`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            userType: filterData.userType,
        })
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(response.status);
        }
    }).then((data) => {
        return data;
    }).catch((error) => {
        throw new Error(error);
    });
}

export const getRegisteredUsersReportCsv = (filterData) => {
    let headers = {};
    if (localStorage.getItem("access") != null) {
        headers = {
            Authorization: "Bearer " + localStorage.getItem("access"),
            "Content-Type": "application/json"
        };
    }

    return fetch(API_URL + `/api/v1/reports/registered-users/export`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            start: filterData.range[0].format('YYYY-MM-DD'),
            end: filterData.range[1].format('YYYY-MM-DD'),
            userType: filterData.userType,
        })
    }).then((response) => {
        if (response.ok) {
            const disposition = response.headers.get('Content-Disposition');
            let filename = 'registered_users_report_data.csv';

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            return response.blob().then(blob => ({ blob, filename }));
        } else {
            throw new Error(response.status);
        }
    }).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return link;
    }).catch((error) => {
        throw new Error(error);
    });
}
